import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { trackPageView } from '../utils/analytics';
import SEOHead from '../components/SEOHead';

const terms = [
  "Our responsibility ceases as soon as the consignment is handed over to the buyer and we receive confirmation.",
  "In the event of any damage noticed to the cement bags while taking delivery; please get the bags surveyed in the presence of the deliverer.",
  "We provide resolution only if the matter is raised within 3 days regarding torn bags, bag quantity shortage, theft by the transporter, and quality issues within 7 days.",
  "It will be assumed that the consignment has been received in good condition in absence of any report to the contrary immediately upon receipt. Any gap to be noted on the challan.",
  "Supply is subject to the availability of cement in the desired pack/brand and type.",
  "Price at which the order is placed is valid for the given order for which the payment is made.",
  "Delivery time is indicative and actual delivery time could be at variance.",
  "Company is responsible for the quality of cement as per BIS standards.",
  "The company reserves the right to cancel any order it deems fit, without assigning any reason. The refund of the same is to happen within 7 days or before through the original payment mode.",
  "While all efforts would be made to deliver on time, in case of any delay the company would keep the customer informed and would not be liable for any damages.",
  "Conditions beyond the control of the company such as natural calamities, strikes, or acts of God could disrupt dispatch/availability, for which the company will not be held responsible.",
  "Prices are subject to change as per changes in Government policy / Taxes / Freight.",
  "If delivery is required to inaccessible areas or higher levels of a building, any additional charge would be borne by the buyer.",
  "Avi Cement Limited reserves the right to modify or change all prices, schemes, awards, bonuses, redemption, rewards and dispatches, etc. The same can be altered, modified, or stopped at the sole discretion of the company.",
  "Block Manufacturing Association authorizes 2% breakage of Cement Blocks hence the customer will bear that cost. Avi Cement Limited is not responsible for the authorized breakage."
];

const TermsPage = () => {
  useEffect(() => { trackPageView('/terms', 'Terms & Conditions'); }, []);

  return (
    <div className="min-h-screen bg-void" data-testid="terms-page">
      <SEOHead
        title="Terms of Service"
        description="Terms and conditions for using the Avi Cement Limited website and services."
        path="/terms"
        noindex
      />
      <section className="relative py-12 md:py-28 overflow-hidden">
        <div className="absolute inset-0 bg-grid opacity-20" />
        <div className="container mx-auto px-4 md:px-8 max-w-4xl relative z-10">
          <Link to="/" className="inline-flex items-center gap-2 text-gray-400 hover:text-white text-sm mb-8 transition-colors">
            <ArrowLeft className="w-4 h-4" /> Back to Home
          </Link>
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <span className="text-coral font-mono text-sm mb-4 block">LEGAL</span>
            <h1 className="font-display text-4xl md:text-5xl font-bold text-white mb-4">Terms & Conditions</h1>
            <p className="text-gray-500 text-sm font-mono">Last updated: March 2026</p>
          </motion.div>
        </div>
      </section>

      <section className="pb-20 md:pb-32">
        <div className="container mx-auto px-4 md:px-8 max-w-4xl">
          <div className="bg-surface border border-white/5 rounded-2xl p-8 md:p-12 space-y-6">
            {terms.map((term, i) => (
              <div key={i} className="flex gap-4 items-start">
                <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-coral/10 text-coral flex items-center justify-center font-mono text-sm font-medium">{i + 1}</span>
                <p className="text-gray-300 text-sm leading-relaxed pt-1">{term}</p>
              </div>
            ))}

            <div className="border-t border-white/5 pt-8 mt-8">
              <h2 className="font-display text-xl font-semibold text-white mb-4">Limitation of Liability</h2>
              <p className="text-gray-400 text-sm leading-relaxed">Under no circumstances shall Avi Cement Limited or avicement.com, any of its partners, or developers be liable to any user/member/customer on account of that user's use or misuse of or reliance on our website, arising from any claim relating to these terms or an error in the website or the program or associated websites. Such limitation of liability shall apply to prevent recovery of direct, indirect, incidental, consequential, special, exemplary, and punitive damages whether such claim is based on warranty, contract, tort (including negligence), indemnity, or otherwise.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
